import setGlobalState from '../../../redux/setGlobalState';
import store from '../../../store';
import type {AiAgentPendingFeedback, AiAgentProposalOwner} from '../../../redux/aiAgent/aiAgent.type';

/**
 * The record the chat asked for exists, so the chat is over and the producer is asked how it
 * went. The owner travels with the request like it does with a proposal: the feedback is
 * posted to the event/package the chat ran under, wherever the producer is by then.
 */
export function requestAgentFeedback(owner: AiAgentProposalOwner, sessionId: string): void {
    const feedback: AiAgentPendingFeedback = {...owner, sessionId, status: 'pending'};
    setGlobalState('aiAgent.pendingFeedback', feedback);
}

/** The producer moved on: another message, a new chat, or "not now". */
export function clearAgentFeedbackRequest(): void {
    setGlobalState('aiAgent.pendingFeedback', null);
}

/** The card stays as a thank-you until the chat moves on, so the same chat is not asked twice. */
export function markAgentFeedbackSent(): void {
    const pending = store.getState().aiAgent?.pendingFeedback;
    if(pending) {
        setGlobalState('aiAgent.pendingFeedback', {...pending, status: 'sent'});
    }
}
